import * as React from 'react';
import { RouteComponentProps } from 'react-router';
import { SurveyStep } from '../../models';
import { PageStateSetterBaseProps } from './PageStateSetterBase';
import { SurveyPageStateSetter } from './SurveyPageStateSetter';

export type AudiencePageStateSetterRouteProps = RouteComponentProps<{ surveyId: string; audienceId: string }> | undefined;

export type AudiencePageStateSetterProps = {
	match: { params: { surveyId?: string; audienceId?: string } };
	Get?: (surveyId: number, audienceId: number) => void;
} & PageStateSetterBaseProps;

export class AudiencePageStateSetterBase extends React.Component<AudiencePageStateSetterProps, { openWarningModal: boolean }> {
	public componentDidMount() {
		const { currentStep, InitializePage, Get } = this.props;

		if (this.props.match.params.surveyId) {
			const paramsSurveyId = parseInt(this.props.match.params.surveyId, 10);

			InitializePage(paramsSurveyId, currentStep);
			if (this.props.match.params.audienceId) {
				const paramsAudienceId = parseInt(this.props.match.params.audienceId, 10);
				if (Get !== undefined) {
					Get(paramsSurveyId, paramsAudienceId);
				}
			}
		}
	}

	public render() {
		return <SurveyPageStateSetter {...this.props} currentStep={SurveyStep.Distribution} />;
	}
}
